import React from 'react';
import NewMypageAsWrapper from 'components/NewMypageAsWrapper';

export default function NewMypageAsContainer() {
  return <NewMypageAsWrapper />;
}
